<template lang="pug">
  v-treeview(
    id="tree"
    v-model="nodes"
    :items="addressesTree"
    transition=true
    open-on-click
    selectable
    return-object
    @input="handleNodesInput"
  )
</template>
<script>
export default {
  props: {
    addresses: {
      type: Object,
    }
  },
  data() {
    return {
      nodes: [],
      shouldToggleVisibility: false,
      asyncProcess: false,
      prevNodes: [],
    }
  },
  mounted() {
    this.resetNodes()
    this.asyncProcess = true;
  },
  watch: {
    asyncProcess(newVal) {
      if(!newVal) {
        this.toggleUpdateVisibility();
      }
    },
    addresses(newVal) {
      if(!this.shouldToggleVisibility) {
        this.asyncProcess = true;
        this.resetNodes();
      }
    },
  },
  computed: {
    addressesTree() {
      var addressesTree = [];
      for (let address in this.addresses) {
        addressesTree.push({
          'id': address,
          'name': address,
          'parent': true,
          'children': this.addresses[address].map( child => {
            return {
              'id': child.text,
              'name': child.text,
              'parent': false
            }
          })
        });
      }
      return [
        {
          'id': 1,
          'name': "Address",
          'parent': true,
          'children': addressesTree
        }
      ];
    }
  },
  methods: {
    resetNodes() {
      this.nodes = this.activeNodes(this.addresses);
      this.prevNodes = this.nodes;
    },
    handleNodesInput(currentNodes) {
      if(!this.shouldToggleVisibility) {
        this.asyncProcess = false;
        this.resetNodes()
        return;
      }
      [currentNodes, this.prevNodes] = this.removeParentNodes(currentNodes, this.prevNodes);
      const [biggerNode, smallerNode] = this.orderNodesValues(this.prevNodes, currentNodes);
      const diffNodes = this.getDiffNodes(biggerNode, smallerNode);

      this.emitVisibilityChange(diffNodes);
      this.prevNodes = currentNodes;
    },
    toggleUpdateVisibility() {
      this.shouldToggleVisibility = !this.shouldToggleVisibility;
    },
    orderNodesValues(oldValue, newValue) {
      if (oldValue.length < newValue.length) {
        return [newValue, oldValue];
      }
      return [oldValue, newValue];
    },
    activeNodes(addresses) {
      let activeNodes = [];
      Object.values(addresses).forEach(addressType => {
        Object.values(addressType).forEach(node => {
          if(node.visible) {
            activeNodes.push({ id: node.text, name: node.text });
          }
        });
      });
      return activeNodes;
    },
    emitVisibilityChange(nodes) {
      nodes.forEach(node => {
        this.$emit('change', node);
      });
    },
    getDiffNodes(biggerNodes, smallerNodes) {
      const biggerNodesName = Object.values(biggerNodes).map(node => node.name);
      const smallerNodesName = Object.values(smallerNodes).map(node => node.name)
      return biggerNodesName.filter(node => !smallerNodesName.includes(node));
    },
    unselectAll() {
      this.toggleUpdateVisibility();
      this.asyncProcess = true;
      this.nodes = [];
    },
    removeParentNodes(current, prev) {
      const currentN = current.filter(node => !node.parent);
      const prevN = prev.filter(node => !node.parent);
      return [currentN, prevN];
    }
  },
};
</script>
